import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EffectsModule } from '@ngrx/effects';
import { PhotoEffects } from './photo-store/photo.effects';
import { InternalSharedModule } from '../shared';
import {
  PhotoGalleryComponent,
  EditPhotoPaneComponent,
  AddPhotosModalComponent,
  BulkAssignComponentModalComponent,
} from './components';
import { PhotoListComponent } from './pages';
import { services } from './shared/services';
import { photoRoutes } from './photo.routing';
import { DxTooltipModule } from 'devextreme-angular';

const PROVIDERS = [
  ...services
];

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([PhotoEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    RouterModule.forChild(photoRoutes),
    SharedModule,
    DxTooltipModule
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [

    /* Pages */
    PhotoListComponent,

    /* Components */
    PhotoGalleryComponent,
    EditPhotoPaneComponent,
    AddPhotosModalComponent,
    BulkAssignComponentModalComponent,
  ],
  exports: [
  ]
})
export class PhotoModule { }
